export const DIALECT_API_TYPE_DIALECT_CLOUD = 'dialect-cloud';
//# sourceMappingURL=constants.js.map